// ReportDetailsWrapper.jsx or .tsx
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import ReportDetailsTable from './ReportDetailsTable'

const ReportDetailsWrapper = () => {
  const params = useParams()
  const navigate = useNavigate()
  const outletContext = useOutletContext()

  return (
    <ReportDetailsTable
      {...params}
      navigate={navigate}
      outletContext={outletContext}
    />
  )
}

export default ReportDetailsWrapper
